export const isMaintenanceWorkCookieSet = () => {
  const cookie = document.cookie.split(';').find((c) => c.trim().startsWith('lemmeThrough='));
  return cookie ? cookie.split('=')[1] === 'iAmCurious' : false;
};
